window.MinestoneJiuyaCatalog = {
  "beads": [
    {
      "category": "Jade & Stone",
      "name": "Burgundy Garnet",
      "internalName": "酒红石榴石",
      "image": "wine-red-garnet.png",
      "sizes": [
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Blue Fluorite",
      "internalName": "蓝萤石",
      "image": "blue-fluorite.png",
      "sizes": [
        5
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Lapis Lazuli",
      "internalName": "青金石",
      "image": "lapis-lazuli.png",
      "sizes": [
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Hubei Turquoise",
      "internalName": "湖北绿松石",
      "image": "hubei-turquoise.png",
      "sizes": [
        2,
        4
      ],
      "price": 16
    },
    {
      "category": "Agate",
      "name": "Black Onyx",
      "internalName": "黑玛瑙",
      "image": "black-agate.png",
      "sizes": [
        2,
        3,
        4,
        6,
        8,
        10,
        12,
        14,
        16,
        18
      ],
      "price": 16
    },
    {
      "category": "Quartz",
      "name": "Golden Rutilated Quartz",
      "internalName": "金发晶",
      "image": "golden-rutilated-quartz.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Black Rutilated Quartz",
      "internalName": "黑发晶",
      "image": "black-rutilated-quartz.png",
      "sizes": [
        14,
        15,
        16,
        17
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Red Rutilated Quartz",
      "internalName": "红发晶",
      "image": "red-rutilated-quartz.png",
      "sizes": [
        9,
        10,
        11,
        12
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Green Rutilated Quartz",
      "internalName": "绿发晶",
      "image": "green-rutilated-quartz.png",
      "sizes": [
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Silver Sheen Moonstone",
      "internalName": "银月光石",
      "image": "silver-moonstone.png",
      "sizes": [
        10,
        11,
        12
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "White Moonstone",
      "internalName": "白月光石",
      "image": "white-moonstone.png",
      "sizes": [
        4,
        6,
        7,
        8,
        9,
        10,
        11,
        13
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Rainbow Moonstone",
      "internalName": "彩虹月光石",
      "image": "rainbow-moonstone.png",
      "sizes": [
        4,
        5,
        6,
        7,
        8
      ],
      "price": 18
    },
    {
      "category": "Jade & Stone",
      "name": "Rhodochrosite",
      "internalName": "红纹石",
      "image": "rhodochrosite.png",
      "sizes": [
        4,
        5,
        6
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Larimar",
      "internalName": "海纹石",
      "image": "larimar.png",
      "sizes": [
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Charoite",
      "internalName": "紫龙晶",
      "image": "charoite.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Sugilite",
      "internalName": "舒俱莱",
      "image": "sugilite.png",
      "sizes": [
        5,
        6,
        13,
        15,
        16,
        17
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Tanzanite",
      "internalName": "坦桑石",
      "image": "tanzanite.png",
      "sizes": [
        3,
        6,
        7,
        8,
        9
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Pietersite",
      "internalName": "彼得石",
      "image": "pietersite.png",
      "sizes": [
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Iolite",
      "internalName": "堇青石",
      "image": "iolite.png",
      "sizes": [
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Golden Sunstone",
      "internalName": "金太阳石",
      "image": "golden-sunstone.png",
      "sizes": [
        4,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ],
      "price": 16
    },
    {
      "category": "Crystal",
      "name": "Herkimer Diamond Quartz",
      "internalName": "闪灵钻",
      "image": "jiuya-021.png",
      "sizes": [
        10,
        15,
        16,
        18
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "White Rabbit Hair Quartz",
      "internalName": "白兔毛",
      "image": "jiuya-022.png",
      "sizes": [
        7,
        10,
        11,
        12,
        13,
        14
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Red Rabbit Hair Quartz",
      "internalName": "红兔毛",
      "image": "jiuya-023.png",
      "sizes": [
        11,
        12
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Blue Rabbit Hair Quartz",
      "internalName": "蓝兔毛",
      "image": "jiuya-024.png",
      "sizes": [
        6,
        7,
        9,
        10,
        11,
        15
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "White Snow Phantom Quartz",
      "internalName": "白雪花幽灵",
      "image": "jiuya-025.png",
      "sizes": [
        3,
        4,
        5,
        6,
        7,
        8,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Grey Moonstone",
      "internalName": "灰月光石",
      "image": "jiuya-026.png",
      "sizes": [
        4,
        5,
        6,
        7,
        8,
        9
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Four Seasons Phantom Quartz",
      "internalName": "四季幽灵",
      "image": "jiuya-027.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14
      ],
      "price": 18
    },
    {
      "category": "Crystal",
      "name": "Black Gold Super Seven Quartz",
      "internalName": "黑金超七",
      "image": "jiuya-028.png",
      "sizes": [
        4,
        5,
        6,
        7,
        9,
        11,
        13,
        14,
        15,
        16,
        17,
        18
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Deep Green Starry Phantom Quartz",
      "internalName": "墨绿星沙绿幽灵",
      "image": "jiuya-029.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17
      ],
      "price": 18
    },
    {
      "category": "Crystal",
      "name": "Dendritic Quartz",
      "internalName": "小树水晶",
      "image": "jiuya-030.png",
      "sizes": [
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Flower Phantom Quartz",
      "internalName": "花幽灵",
      "image": "jiuya-031.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Titanium Rutilated Quartz",
      "internalName": "钛晶",
      "image": "jiuya-032.png",
      "sizes": [
        5
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Silver Rutilated Quartz",
      "internalName": "银发晶",
      "image": "jiuya-033.png",
      "sizes": [
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18
      ],
      "price": 18
    },
    {
      "category": "Amethyst",
      "name": "Light Amethyst",
      "internalName": "浅紫水晶",
      "image": "jiuya-034.png",
      "sizes": [
        4,
        5,
        6,
        7,
        8,
        10,
        11,
        13,
        15,
        16,
        17,
        18
      ],
      "price": 18
    },
    {
      "category": "Crystal",
      "name": "Yellow Azeztulite Quartz",
      "internalName": "黄水晶阿赛",
      "image": "jiuya-035.png",
      "sizes": [
        8,
        9,
        10,
        11,
        12
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Copper Rutilated Quartz",
      "internalName": "铜发晶",
      "image": "jiuya-036.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Blue Rutilated Quartz",
      "internalName": "蓝发晶",
      "image": "jiuya-037.png",
      "sizes": [
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16
      ],
      "price": 18
    },
    {
      "category": "Crystal",
      "name": "Madagascar Rose Quartz",
      "internalName": "马达加斯加粉晶",
      "image": "jiuya-038.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Pink Snow Phantom Quartz",
      "internalName": "粉雪花幽灵",
      "image": "jiuya-039.png",
      "sizes": [
        3,
        4,
        5,
        6,
        7,
        8,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "White Phantom Quartz",
      "internalName": "白幽灵",
      "image": "jiuya-040.png",
      "sizes": [
        7,
        8,
        9,
        12,
        13,
        14,
        15,
        16,
        17,
        18
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Monet Phantom Quartz",
      "internalName": "莫奈幽灵",
      "image": "jiuya-041.png",
      "sizes": [
        7,
        8,
        9,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Emerald Phantom Quartz",
      "internalName": "翠幽灵",
      "image": "jiuya-042.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Limonite-Inclusion Quartz",
      "internalName": "胶花水晶",
      "image": "jiuya-043.png",
      "sizes": [
        13,
        14,
        15,
        16
      ],
      "price": 18
    },
    {
      "category": "Agate",
      "name": "Agate",
      "internalName": "玛瑙",
      "image": "jiuya-044.png",
      "sizes": [
        8,
        10
      ],
      "price": 16
    },
    {
      "category": "Phantom Quartz",
      "name": "Matcha Green Phantom Quartz",
      "internalName": "抹茶幽灵",
      "image": "jiuya-045.png",
      "sizes": [
        6,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Pink-Purple Rabbit Hair Quartz",
      "internalName": "粉紫兔毛",
      "image": "jiuya-046.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        15
      ],
      "price": 18
    },
    {
      "category": "Agate",
      "name": "Blue Lace Agate",
      "internalName": "蓝纹玛瑙",
      "image": "jiuya-047.png",
      "sizes": [
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18
      ],
      "price": 16
    },
    {
      "category": "Crystal",
      "name": "Pink-Purple Super Seven Quartz",
      "internalName": "粉紫超七",
      "image": "jiuya-048.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        15,
        16
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Yellow Phantom Quartz",
      "internalName": "黄幽灵",
      "image": "jiuya-049.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        15,
        16
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Multicolour Rutilated Quartz",
      "internalName": "彩发晶",
      "image": "jiuya-050.png",
      "sizes": [
        8,
        9,
        10,
        12
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Pink Phantom Quartz",
      "internalName": "粉幽灵",
      "image": "jiuya-051.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        18
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Red Phantom Quartz",
      "internalName": "红幽灵",
      "image": "jiuya-052.png",
      "sizes": [
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Grey Phantom Quartz",
      "internalName": "灰幽灵",
      "image": "jiuya-053.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Black Phantom Quartz",
      "internalName": "黑幽灵",
      "image": "jiuya-054.png",
      "sizes": [
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Scenic Inclusion Quartz",
      "internalName": "异象胶花",
      "image": "jiuya-055.png",
      "sizes": [
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Devil Silver Rutilated Quartz",
      "internalName": "魔鬼银发晶",
      "image": "jiuya-056.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        17
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Blue Phantom Quartz",
      "internalName": "蓝幽灵",
      "image": "jiuya-057.png",
      "sizes": [
        6,
        7,
        8,
        9,
        10
      ],
      "price": 18
    },
    {
      "category": "Jade & Stone",
      "name": "Blue Topaz",
      "internalName": "蓝托帕石",
      "image": "jiuya-058.png",
      "sizes": [
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Pink Lepidolite",
      "internalName": "粉锂云母",
      "image": "jiuya-059.png",
      "sizes": [
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        18
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Fuchsite",
      "internalName": "绿云母",
      "image": "jiuya-060.png",
      "sizes": [
        6,
        7,
        8,
        10
      ],
      "price": 16
    },
    {
      "category": "Phantom Quartz",
      "name": "Rainbow Phantom Quartz",
      "internalName": "彩幽灵",
      "image": "jiuya-061.png",
      "sizes": [
        6,
        8,
        9,
        10,
        11,
        12,
        13,
        14
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Frost Phantom Rutilated Quartz",
      "internalName": "雪霜幽灵发",
      "image": "jiuya-062.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Red-Green Phantom Quartz",
      "internalName": "红绿幽灵",
      "image": "jiuya-063.png",
      "sizes": [
        10,
        11,
        12,
        14,
        15,
        16,
        17
      ],
      "price": 18
    },
    {
      "category": "Jade & Stone",
      "name": "Chalcopyrite",
      "internalName": "黄铜矿",
      "image": "jiuya-064.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Green Apatite",
      "internalName": "绿磷灰石",
      "image": "jiuya-065.png",
      "sizes": [
        5,
        6,
        7,
        8,
        9,
        10
      ],
      "price": 16
    },
    {
      "category": "Quartz",
      "name": "Cherry Strawberry Quartz",
      "internalName": "车厘子草莓晶",
      "image": "jiuya-066.png",
      "sizes": [
        17,
        18
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Purple Rabbit Hair Quartz",
      "internalName": "紫兔毛",
      "image": "jiuya-067.png",
      "sizes": [
        7
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Blue Needle Rabbit Hair Quartz",
      "internalName": "蓝线兔毛",
      "image": "jiuya-068.png",
      "sizes": [
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13
      ],
      "price": 18
    },
    {
      "category": "Agate",
      "name": "Yanyuan Agate",
      "internalName": "盐源玛瑙",
      "image": "jiuya-069.png",
      "sizes": [
        7,
        8,
        9,
        10
      ],
      "price": 16
    },
    {
      "category": "Quartz",
      "name": "Milky Tea Moonstone",
      "internalName": "奶茶月光石",
      "image": "jiuya-070.png",
      "sizes": [
        11,
        13,
        14,
        15
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Layered Green Phantom Quartz",
      "internalName": "千层绿幽灵",
      "image": "jiuya-071.png",
      "sizes": [
        16
      ],
      "price": 18
    },
    {
      "category": "Jade & Stone",
      "name": "Golden Lepidolite",
      "internalName": "黄锂云母",
      "image": "jiuya-072.png",
      "sizes": [
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18
      ],
      "price": 16
    },
    {
      "category": "Quartz",
      "name": "Green Strawberry Quartz",
      "internalName": "绿草莓晶",
      "image": "jiuya-073.png",
      "sizes": [
        5,
        6,
        7,
        8,
        9,
        10,
        11
      ],
      "price": 18
    },
    {
      "category": "Jade & Stone",
      "name": "Yellow Topaz",
      "internalName": "黄托帕石",
      "image": "jiuya-074.png",
      "sizes": [
        6,
        7,
        8,
        9,
        11,
        12
      ],
      "price": 16
    },
    {
      "category": "Quartz",
      "name": "Cat's-Eye Green Rutilated Quartz",
      "internalName": "猫眼绿发晶",
      "image": "jiuya-075.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Golden Rabbit Hair Quartz",
      "internalName": "兔毛金发晶",
      "image": "jiuya-076.png",
      "sizes": [
        9,
        10,
        11,
        12,
        13,
        14
      ],
      "price": 18
    },
    {
      "category": "Jade & Stone",
      "name": "Purple Lepidolite",
      "internalName": "紫锂云母",
      "image": "jiuya-077.png",
      "sizes": [
        6,
        7,
        8,
        10,
        12,
        14,
        15
      ],
      "price": 16
    },
    {
      "category": "Agate",
      "name": "Alashan Agate",
      "internalName": "阿拉善玛瑙",
      "image": "jiuya-078.png",
      "sizes": [
        8,
        10,
        12
      ],
      "price": 16
    },
    {
      "category": "Phantom Quartz",
      "name": "Golden Mist Phantom Quartz",
      "internalName": "金雾幽灵",
      "image": "jiuya-079.png",
      "sizes": [
        12,
        13,
        14,
        15,
        16,
        18
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Champagne Snow Phantom Quartz",
      "internalName": "香槟雪花幽灵",
      "image": "jiuya-080.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12
      ],
      "price": 18
    },
    {
      "category": "Crystal",
      "name": "Green Super Seven Quartz",
      "internalName": "绿超七",
      "image": "jiuya-081.png",
      "sizes": [
        9,
        10,
        15,
        18
      ],
      "price": 18
    },
    {
      "category": "Quartz",
      "name": "Venus Hair Quartz",
      "internalName": "维纳斯发晶",
      "image": "jiuya-082.png",
      "sizes": [
        10,
        11,
        12
      ],
      "price": 18
    },
    {
      "category": "Crystal",
      "name": "Fairy Super Seven Quartz",
      "internalName": "仙女超七",
      "image": "jiuya-083.png",
      "sizes": [
        7,
        10
      ],
      "price": 18
    },
    {
      "category": "Jade & Stone",
      "name": "Purple Phantom Fluorite",
      "internalName": "紫萤石幽灵",
      "image": "jiuya-084.png",
      "sizes": [
        9,
        10,
        11,
        12,
        13
      ],
      "price": 16
    },
    {
      "category": "Crystal",
      "name": "Golden Smoky Quartz",
      "internalName": "黄茶晶",
      "image": "jiuya-085.png",
      "sizes": [
        15,
        16,
        17,
        18
      ],
      "price": 18
    },
    {
      "category": "Phantom Quartz",
      "name": "Pink-Red Phantom Quartz",
      "internalName": "红粉幽灵",
      "image": "jiuya-086.png",
      "sizes": [
        9,
        10
      ],
      "price": 18
    },
    {
      "category": "Agate",
      "name": "Nanhong Agate",
      "internalName": "南红玛瑙",
      "image": "jiuya-087.png",
      "sizes": [
        2,
        3
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Purple Mica",
      "internalName": "紫云母",
      "image": "jiuya-088.png",
      "sizes": [
        6,
        9
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "K2 Granite",
      "internalName": "K2",
      "image": "jiuya-089.png",
      "sizes": [
        11,
        12
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Australian Jade (Chrysoprase)",
      "internalName": "澳洲玉",
      "image": "jiuya-090.png",
      "sizes": [
        7
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "White Topaz",
      "internalName": "白托帕石",
      "image": "jiuya-091.png",
      "sizes": [
        8,
        12
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Mystic Topaz",
      "internalName": "彩托帕石",
      "image": "jiuya-092.png",
      "sizes": [
        7
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Black Elestial Quartz",
      "internalName": "黑骨干水晶",
      "image": "jiuya-093.png",
      "sizes": [
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Fuchsite",
      "internalName": "祖母晶",
      "image": "jiuya-094.png",
      "sizes": [
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Blue Opal",
      "internalName": "蓝奥宝",
      "image": "jiuya-095.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Red Auralite-23",
      "internalName": "红极光",
      "image": "jiuya-096.png",
      "sizes": [
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17
      ],
      "price": 16
    },
    {
      "category": "Amethyst",
      "name": "Purple Jade Crystal",
      "internalName": "紫玉晶",
      "image": "jiuya-097.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ],
      "price": 18
    },
    {
      "category": "Jade & Stone",
      "name": "Pink Opal",
      "internalName": "粉奥宝",
      "image": "jiuya-098.png",
      "sizes": [
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17
      ],
      "price": 16
    },
    {
      "category": "Crystal",
      "name": "Snow Azeztulite Quartz",
      "internalName": "冰雪阿赛",
      "image": "jiuya-099.png",
      "sizes": [
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18
      ],
      "price": 18
    },
    {
      "category": "Jade & Stone",
      "name": "Fanta Auralite-23",
      "internalName": "芬达极光",
      "image": "jiuya-100.png",
      "sizes": [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ],
      "price": 16
    },
    {
      "category": "Crystal",
      "name": "Green Azeztulite Quartz",
      "internalName": "绿阿赛",
      "image": "jiuya-101.png",
      "sizes": [
        7,
        8,
        10,
        12,
        13,
        15,
        17,
        18
      ],
      "price": 18
    },
    {
      "category": "Jade & Stone",
      "name": "Phoenix Stone",
      "internalName": "凤凰松石",
      "image": "jiuya-102.png",
      "sizes": [
        9,
        10,
        11,
        12,
        13,
        14
      ],
      "price": 16
    },
    {
      "category": "Crystal",
      "name": "Pink Azeztulite Quartz",
      "internalName": "粉阿赛",
      "image": "jiuya-103.png",
      "sizes": [
        8,
        10,
        11,
        13,
        14,
        15,
        16,
        17
      ],
      "price": 18
    },
    {
      "category": "Crystal",
      "name": "Purple Azeztulite Quartz",
      "internalName": "紫阿赛",
      "image": "jiuya-104.png",
      "sizes": [
        7,
        8,
        9,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18
      ],
      "price": 18
    },
    {
      "category": "Jade & Stone",
      "name": "Hypersthene",
      "internalName": "金运石",
      "image": "jiuya-105.png",
      "sizes": [
        6,
        7,
        8,
        9,
        11,
        13,
        15,
        17
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "White Andesine Feldspar",
      "internalName": "白色安德森",
      "image": "jiuya-106.png",
      "sizes": [
        12,
        13
      ],
      "price": 16
    },
    {
      "category": "Jade & Stone",
      "name": "Green Quartz (Prasiolite)",
      "internalName": "绿水晶",
      "image": "jiuya-107.png",
      "sizes": [
        13
      ],
      "price": 16
    }
  ],
  "imageFillRatios": {
    "wine-red-garnet.png": 0.585,
    "blue-fluorite.png": 0.613,
    "lapis-lazuli.png": 0.56,
    "hubei-turquoise.png": 0.566,
    "black-agate.png": 0.559,
    "golden-rutilated-quartz.png": 0.649,
    "black-rutilated-quartz.png": 0.628,
    "red-rutilated-quartz.png": 0.554,
    "green-rutilated-quartz.png": 0.59,
    "silver-moonstone.png": 0.697,
    "white-moonstone.png": 0.735,
    "rainbow-moonstone.png": 0.729,
    "rhodochrosite.png": 0.781,
    "larimar.png": 0.725,
    "charoite.png": 0.709,
    "sugilite.png": 0.726,
    "tanzanite.png": 0.635,
    "pietersite.png": 0.728,
    "iolite.png": 0.605,
    "golden-sunstone.png": 0.738,
    "jiuya-021.png": 0.653,
    "jiuya-022.png": 0.725,
    "jiuya-023.png": 0.691,
    "jiuya-024.png": 0.667,
    "jiuya-025.png": 0.758,
    "jiuya-026.png": 0.649,
    "jiuya-027.png": 0.712,
    "jiuya-028.png": 0.705,
    "jiuya-029.png": 0.779,
    "jiuya-030.png": 0.769,
    "jiuya-031.png": 0.677,
    "jiuya-032.png": 0.661,
    "jiuya-033.png": 0.68,
    "jiuya-034.png": 0.774,
    "jiuya-035.png": 0.662,
    "jiuya-036.png": 0.662,
    "jiuya-037.png": 0.606,
    "jiuya-038.png": 0.722,
    "jiuya-039.png": 0.677,
    "jiuya-040.png": 0.628,
    "jiuya-041.png": 0.624,
    "jiuya-042.png": 0.682,
    "jiuya-043.png": 0.675,
    "jiuya-044.png": 0.577,
    "jiuya-045.png": 0.62,
    "jiuya-046.png": 0.6,
    "jiuya-047.png": 0.617,
    "jiuya-048.png": 0.706,
    "jiuya-049.png": 0.666,
    "jiuya-050.png": 0.72,
    "jiuya-051.png": 0.804,
    "jiuya-052.png": 0.705,
    "jiuya-053.png": 0.728,
    "jiuya-054.png": 0.678,
    "jiuya-055.png": 0.808,
    "jiuya-056.png": 0.702,
    "jiuya-057.png": 0.617,
    "jiuya-058.png": 0.73,
    "jiuya-059.png": 0.621,
    "jiuya-060.png": 0.707,
    "jiuya-061.png": 0.631,
    "jiuya-062.png": 0.521,
    "jiuya-063.png": 0.557,
    "jiuya-064.png": 0.557,
    "jiuya-065.png": 0.662,
    "jiuya-066.png": 0.732,
    "jiuya-067.png": 0.691,
    "jiuya-068.png": 0.578,
    "jiuya-069.png": 0.654,
    "jiuya-070.png": 0.73,
    "jiuya-071.png": 0.662,
    "jiuya-072.png": 0.719,
    "jiuya-073.png": 0.635,
    "jiuya-074.png": 0.683,
    "jiuya-075.png": 0.666,
    "jiuya-076.png": 0.697,
    "jiuya-077.png": 0.732,
    "jiuya-078.png": 0.724,
    "jiuya-079.png": 0.772,
    "jiuya-080.png": 0.715,
    "jiuya-081.png": 0.616,
    "jiuya-082.png": 0.7,
    "jiuya-083.png": 0.703,
    "jiuya-084.png": 0.625,
    "jiuya-085.png": 0.683,
    "jiuya-086.png": 0.667,
    "jiuya-087.png": 0.734,
    "jiuya-088.png": 0.624,
    "jiuya-089.png": 0.707,
    "jiuya-090.png": 0.53,
    "jiuya-091.png": 0.606,
    "jiuya-092.png": 0.633,
    "jiuya-093.png": 0.769,
    "jiuya-094.png": 0.663,
    "jiuya-095.png": 0.715,
    "jiuya-096.png": 0.703,
    "jiuya-097.png": 0.635,
    "jiuya-098.png": 0.679,
    "jiuya-099.png": 0.72,
    "jiuya-100.png": 0.641,
    "jiuya-101.png": 0.701,
    "jiuya-102.png": 0.574,
    "jiuya-103.png": 0.777,
    "jiuya-104.png": 0.778,
    "jiuya-105.png": 0.729,
    "jiuya-106.png": 0.679,
    "jiuya-107.png": 0.699
  },
  "imageRoundnessFix": {
    "wine-red-garnet.png": 1.019,
    "blue-fluorite.png": 1.028,
    "lapis-lazuli.png": 1.013,
    "hubei-turquoise.png": 1.023,
    "black-agate.png": 1.01,
    "golden-rutilated-quartz.png": 1.006,
    "black-rutilated-quartz.png": 1.025,
    "red-rutilated-quartz.png": 1.015,
    "green-rutilated-quartz.png": 1.016,
    "silver-moonstone.png": 1.04,
    "white-moonstone.png": 1.021,
    "rainbow-moonstone.png": 1.014,
    "rhodochrosite.png": 1.019,
    "larimar.png": 1.033,
    "charoite.png": 1.002,
    "sugilite.png": 0.999,
    "tanzanite.png": 1.017,
    "pietersite.png": 1.033,
    "iolite.png": 1.026,
    "golden-sunstone.png": 1.029,
    "jiuya-021.png": 1.015,
    "jiuya-022.png": 1.022,
    "jiuya-023.png": 1.013,
    "jiuya-024.png": 1.013,
    "jiuya-025.png": 1.021,
    "jiuya-026.png": 1.005,
    "jiuya-027.png": 1.014,
    "jiuya-028.png": 1.027,
    "jiuya-029.png": 1.018,
    "jiuya-030.png": 1.014,
    "jiuya-031.png": 1.046,
    "jiuya-032.png": 1.005,
    "jiuya-033.png": 1.031,
    "jiuya-034.png": 1.019,
    "jiuya-035.png": 1.017,
    "jiuya-036.png": 1.012,
    "jiuya-037.png": 1.02,
    "jiuya-038.png": 1.019,
    "jiuya-039.png": 1.023,
    "jiuya-040.png": 1.021,
    "jiuya-041.png": 1.034,
    "jiuya-042.png": 1.015,
    "jiuya-043.png": 1.024,
    "jiuya-044.png": 1.027,
    "jiuya-045.png": 1.039,
    "jiuya-046.png": 1.011,
    "jiuya-047.png": 1.035,
    "jiuya-048.png": 1.039,
    "jiuya-049.png": 1.025,
    "jiuya-050.png": 1.018,
    "jiuya-051.png": 1.012,
    "jiuya-052.png": 1.021,
    "jiuya-053.png": 1.038,
    "jiuya-054.png": 1.03,
    "jiuya-055.png": 1.035,
    "jiuya-056.png": 1.01,
    "jiuya-057.png": 1.025,
    "jiuya-058.png": 1.012,
    "jiuya-059.png": 1.028,
    "jiuya-060.png": 1.031,
    "jiuya-061.png": 1.026,
    "jiuya-062.png": 1.017,
    "jiuya-063.png": 1.007,
    "jiuya-064.png": 1.013,
    "jiuya-065.png": 0.992,
    "jiuya-066.png": 1.02,
    "jiuya-067.png": 1.019,
    "jiuya-068.png": 1.043,
    "jiuya-069.png": 1.03,
    "jiuya-070.png": 1.034,
    "jiuya-071.png": 1.012,
    "jiuya-072.png": 1.048,
    "jiuya-073.png": 1.017,
    "jiuya-074.png": 1.019,
    "jiuya-075.png": 1.022,
    "jiuya-076.png": 1.023,
    "jiuya-077.png": 1.018,
    "jiuya-078.png": 1.035,
    "jiuya-079.png": 1.017,
    "jiuya-080.png": 1.037,
    "jiuya-081.png": 1.021,
    "jiuya-082.png": 1.007,
    "jiuya-083.png": 1.014,
    "jiuya-084.png": 1.012,
    "jiuya-085.png": 1.015,
    "jiuya-086.png": 1.02,
    "jiuya-087.png": 1.04,
    "jiuya-088.png": 1.017,
    "jiuya-089.png": 1.046,
    "jiuya-090.png": 1.023,
    "jiuya-091.png": 1.008,
    "jiuya-092.png": 1.023,
    "jiuya-093.png": 1.016,
    "jiuya-094.png": 1.004,
    "jiuya-095.png": 1.002,
    "jiuya-096.png": 1.008,
    "jiuya-097.png": 1.022,
    "jiuya-098.png": 1.016,
    "jiuya-099.png": 1.023,
    "jiuya-100.png": 1.015,
    "jiuya-101.png": 1.019,
    "jiuya-102.png": 1.032,
    "jiuya-103.png": 1.018,
    "jiuya-104.png": 1.005,
    "jiuya-105.png": 1.027,
    "jiuya-106.png": 1.032,
    "jiuya-107.png": 1.016
  }
};
